var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 33,
    viewBox: "0 0 26 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 32V28.5556C25 26.7285 24.2776 24.9763 22.9916 23.6844C21.7056 22.3925 19.9615 21.6667 18.1429 21.6667H7.85714C6.03852 21.6667 4.29437 22.3925 3.00841 23.6844C1.72245 24.9763 1 26.7285 1 28.5556V32M19.8571 7.88889C19.8571 11.6935 16.7871 14.7778 13 14.7778C9.2129 14.7778 6.14286 11.6935 6.14286 7.88889C6.14286 4.08426 9.2129 1 13 1C16.7871 1 19.8571 4.08426 19.8571 7.88889Z",
    stroke: "#777777",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileImageIcon);
export default __webpack_public_path__ + "static/media/ProfileImageIcon.be0ba03c6282fbd5d8c0bfd129cfc1c8.svg";
export { ForwardRef as ReactComponent };